import React from "react";
import styled from "styled-components";
import { P } from "../Texts";

const CircleCheckBoxStyle = styled.input`
  background: transparent;

  &,
  &:after,
  &:before {
    border: 1px solid #cecae1;
    border-radius: 5px;
  }

  :checked + label {
    font-weight: 600;
  }

  :checked + label .check-holder > div {
    background: #442ED0;
  }
`;

const CircleStyle = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid #442ed0;
  border-radius: 50%;

  > div {
    width: 10px;
    height: 10px;
    border-radius: 100%;
  }
`;

export const CircleCheckBox = React.forwardRef(
  ({ className, id, name, label, labelColor = "#1E202A" }, ref) => {
    return (
      <div className="relative flex items-center">
        <CircleCheckBoxStyle
          type="checkbox"
          ref={ref}
          name={name}
          id={id}
          className="opacity-0 w-0 h-0"
        />
        {label && (
          <label for={id} className="flex items-center">
            <CircleStyle className="check-holder flex items-center justify-center">
              <div></div>
            </CircleStyle>
            <P color={labelColor} className="ml-4">
              {label}
            </P>
          </label>
        )}
      </div>
    );
  },
);
